import React from "react"

import { Box, TextField } from "@mui/material"

import Loading from "../../../Loading"
import useNotification from "../../../Notification"

import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"

import api from "../../../../api"

import { getSession, saveSession } from "../../../../auth"

class WhatsAppVoiceGeneral extends React.Component {

	constructor(props) {
		super(props)

		const settings = getSession().profile.enterprise.settings

		this.state = {
			loading : false,
			callTtl : settings.wa_call_ttl
		}
	}

	updateConfig = async () => {
		const session = getSession()
		const enterpriseId = session.profile.enterprise.id
		
		this.setState({ loading: true })
		const response = await api.patch(`api/enterprises/${enterpriseId}/`, {
			settings: {
				wa_call_ttl: this.state.callTtl
			}
		})
		this.setState({ loading: false })
		
		if (response.status === 200) {
			session.profile.enterprise.settings.wa_call_ttl = this.state.callTtl
			saveSession(session)
			useNotification("Sucesso!", "Configurações alteradas com sucesso.", "success")
			return
		}
		
		useNotification("Ops!", "Algo deu errado, tente novamente.", "danger")
	}

	render() {
		return (
			<>
				<Loading loading={this.state.loading} />
				{! this.state.loading &&
					<Box className="input-settings">
						<Box sx={{ flex: .8, display:"flex", flexDirection:"column", gap:"1rem" }}>
							<Box className="category-title">
								Tempo para expiração do convite do operador (TTL)
							</Box>
							<TextField
								size="small"
								label="Minutos"
								type="number"
								variant="outlined"
								value={this.state.callTtl}
								onChange={(event) => {
									const onlyDigits = event.target.value.replace(/[^\d]/g, "")
									this.setState({ callTtl: onlyDigits })
								}}
								sx={{ maxWidth: "7.5rem" }}
							/>
							<Box>
								<LoadingButton
									onClick={() => this.updateConfig()}
									loading={this.state.loading}
									loadingPosition="start"
									startIcon={<SaveIcon />}
									variant="contained"
								>
									Salvar
								</LoadingButton>
							</Box>
						</Box>
					</Box>
				}
			</>
		)
	}
}

export default WhatsAppVoiceGeneral
